import { useState } from "react";
import { api, formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { Wallet } from "lucide-react";

export default function PricingSettings() {
  const { user, refresh } = useAuth();
  const [value, setValue] = useState(user?.price_per_session ?? 200);
  const [saving, setSaving] = useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    const price = Number(value);
    if (!Number.isFinite(price) || price < 0 || price > 5000) {
      toast.error("Valor deve estar entre R$ 0 e R$ 5.000");
      return;
    }
    setSaving(true);
    try {
      await api.patch("/professional/pricing", { price_per_session: price });
      await refresh();
      toast.success("Preço atualizado — novas consultas usarão esse valor");
    } catch (err) { toast.error(formatApiError(err)); }
    finally { setSaving(false); }
  };

  return (
    <Card className="card-soft" data-testid="pricing-settings">
      <CardContent className="p-6">
        <div className="flex items-start gap-3">
          <div className="h-10 w-10 rounded-lg bg-teal-100 grid place-items-center text-teal-700 shrink-0">
            <Wallet className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <h3 className="font-display text-base font-semibold text-navy-900">Valor da consulta</h3>
            <p className="text-xs text-slate-500 mt-0.5">
              Valor cobrado por sessão para pacientes particulares (BRL). Consultas SUS não são cobradas.
            </p>
            <form onSubmit={onSave} className="mt-3 flex items-center gap-2 flex-wrap">
              <div className="flex items-center gap-2">
                <span className="text-sm text-slate-500">R$</span>
                <Input
                  type="number"
                  step="1"
                  min="0"
                  max="5000"
                  value={value}
                  onChange={(e) => setValue(e.target.value)}
                  className="w-32"
                  data-testid="pricing-input"
                />
                <span className="text-sm text-slate-500">/ consulta</span>
              </div>
              <Button type="submit" disabled={saving} className="btn-primary" data-testid="pricing-save-btn">
                {saving ? "Salvando…" : "Salvar preço"}
              </Button>
            </form>
            <p className="text-xs text-slate-400 mt-2">
              Não afeta consultas já pagas. Cancelamentos com &gt;24h de antecedência reembolsam automaticamente via Stripe.
            </p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
